import React from "react";
import { Text as Text3 } from "@react-three/drei";
import { useSpring, a, animated } from "@react-spring/three";
import { config } from "@react-spring/core";

const AnimatedText3 = animated(Text3);

export function AxisText({
  x = 0,
  y = 0,
  z = 0,
  capitalize = true,
  color = `rgb(255, 255, 255)`,
  delay = 0,
  font = "assets/fonts/GT-Zirkon-Regular.woff",
  fontSize = 0.5,
  anchorX = "center",
  visible = true,
  rotation = [0, 0, 0],
  text = "",
  ...props
}) {
  const {
    color: aColor,
    visible: aVisible,
    rotation: aRotation,
  } = useSpring({
    visible: Number(visible),
    rotation,
    color: visible ? color : `rgb(0, 0, 0)`,
    config: { ...config.default, duration: 1000 },
    delay,
  });

  return (
    <a.group>
      <AnimatedText3
        userData={text}
        key={`axis-label-${a}`}
        fontSize={fontSize}
        position={[x, y, z]}
        anchorX={anchorX}
        rotation={aRotation}
        font={font}
        fillOpacity={aVisible}
        color={aColor}
        receiveShadow={false}
        castShadow={false}
        depthTest={true}
        {...props}
      >
        {capitalize ? text.toUpperCase() : text}
      </AnimatedText3>
    </a.group>
  );
}
